import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getPagesTravellersInfoDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  baggageGuide: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  singleCabinLuggagePolicy: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  singleCabinLuggagePolicyPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 552,
        height: 357
      }
    },
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Content 1 (EN)",
      fieldValue: "description_english_1",
      className: "col-span-6",
      type: "text",
      name: "description_english_1",
      formType: "richText",
      label: "Content 1 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 1 (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Content 1 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 1 (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Content 1 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 2 (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "richText",
      label: "Content 2 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 2 (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "richText",
      label: "Content 2 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 2 (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "richText",
      label: "Content 2 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 3 (EN)",
      fieldValue: "description_english_3",
      className: "col-span-6",
      type: "text",
      name: "description_english_3",
      formType: "richText",
      label: "Content 3 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 3 (MS)",
      fieldValue: "description_malay_3",
      className: "col-span-6",
      type: "text",
      name: "description_malay_3",
      formType: "richText",
      label: "Content 3 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 3 (ZH)",
      fieldValue: "description_mandarin_3",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_3",
      formType: "richText",
      label: "Content 3 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  singleCabinLuggagePolicyPageImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required", min: 400, max: 400 },
      imageDimension: {
        width: 400,
        height: 260
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  guidelinesForCheckedinLuggage: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  guidelinesForCheckedinLuggagePageContent: [
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  guidelinesForCheckedinLuggagePageImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 290,
        height: 255
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  lagsAndRestrictedItems: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  lags: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  lagsPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 394,
        height: 487
      }
    },
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Section 1 Content (EN)",
      fieldValue: "description_english_1",
      className: "col-span-6",
      type: "text",
      name: "description_english_1",
      formType: "richText",
      label: "Section 1 Content (EN)",
      placeholder: "Enter Section 1 Content (EN)",
      validation: { required: "Section 1 Content (EN) is required" },
    },
    {
      fieldName: "Section 1 Content (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Section 1 Content (MS)",
      placeholder: "Enter Section 1 Content (MS)",
      // validation: { required: "Section 1 Content (MS) is required" },
    },
    {
      fieldName: "Section 1 Content (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Section 1 Content (ZH)",
      placeholder: "Enter Section 1 Content (ZH)",
      // validation: { required: "Section 1 Content (ZH) is required" },
    },
    {
      fieldName: "Section 2 Content (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "input",
      label: "Section 2 Content (EN)",
      placeholder: "Enter Section 2 Content (EN)",
      validation: { required: "Section 2 Content (EN) is required" },
    },
    {
      fieldName: "Section 2 Content (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "input",
      label: "Section 2 Content (MS)",
      placeholder: "Enter Section 2 Content (MS)",
      // validation: { required: "Section 2 Content (MS) is required" },
    },
    {
      fieldName: "Section 2 Content (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "input",
      label: "Section 2 Content (ZH)",
      placeholder: "Enter Section 2 Content (ZH)",
      // validation: { required: "Section 2 Content (ZH) is required" },
    },
    {
      fieldName: "Step 1 Content (EN)",
      fieldValue: "description_english_3",
      className: "col-span-6",
      type: "text",
      name: "description_english_3",
      formType: "richText",
      label: "Step 1 Content (EN)",
      placeholder: "Enter Step 1 Content (EN)",
      validation: { required: "Step 1 Content (EN) is required" },
    },
    {
      fieldName: "Step 1 Content (MS)",
      fieldValue: "description_malay_3",
      className: "col-span-6",
      type: "text",
      name: "description_malay_3",
      formType: "richText",
      label: "Step 1 Content (MS)",
      placeholder: "Enter Step 1 Content (MS)",
      // validation: { required: "Step 1 Content (MS) is required" },
    },
    {
      fieldName: "Step 1 Content (ZH)",
      fieldValue: "description_mandarin_3",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_3",
      formType: "richText",
      label: "Step 1 Content (ZH)",
      placeholder: "Enter Step 1 Content (ZH)",
      // validation: { required: "Step 1 Content (ZH) is required" },
    },
    {
      fieldName: "Step 2 Content (EN)",
      fieldValue: "description_english_4",
      className: "col-span-6",
      type: "text",
      name: "description_english_4",
      formType: "richText",
      label: "Step 2 Content (EN)",
      placeholder: "Enter Step 2 Content (EN)",
      validation: { required: "Step 2 Content (EN) is required" },
    },
    {
      fieldName: "Step 2 Content (MS)",
      fieldValue: "description_malay_4",
      className: "col-span-6",
      type: "text",
      name: "description_malay_4",
      formType: "richText",
      label: "Step 2 Content (MS)",
      placeholder: "Enter Step 2 Content (MS)",
      // validation: { required: "Step 2 Content (MS) is required" },
    },
    {
      fieldName: "Step 2 Content (ZH)",
      fieldValue: "description_mandarin_4",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_4",
      formType: "richText",
      label: "Step 2 Content (ZH)",
      placeholder: "Enter Step 2 Content (ZH)",
      // validation: { required: "Step 2 Content (ZH) is required" },
    },
    {
      fieldName: "Section 3 Content (EN)",
      fieldValue: "description_english_5",
      className: "col-span-6",
      type: "text",
      name: "description_english_5",
      formType: "input",
      label: "Section 3 Content (EN)",
      placeholder: "Enter Section 3 Content (EN)",
      validation: { required: "Section 3 Content (EN) is required" },
    },
    {
      fieldName: "Section 3 Content (MS)",
      fieldValue: "description_malay_5",
      className: "col-span-6",
      type: "text",
      name: "description_malay_5",
      formType: "input",
      label: "Section 3 Content (MS)",
      placeholder: "Enter Section 3 Content (MS)",
      // validation: { required: "Section 3 Content (MS) is required" },
    },
    {
      fieldName: "Section 3 Content (ZH)",
      fieldValue: "description_mandarin_5",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_5",
      formType: "input",
      label: "Section 3 Content (ZH)",
      placeholder: "Enter Section 3 Content (ZH)",
      // validation: { required: "Section 3 Content (ZH) is required" },
    },
  ],
  lagsLiquidItemImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 67,
        height: 65
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  lagsDisclaimerContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "description_english_1",
      className: "col-span-6",
      type: "text",
      name: "description_english_1",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Button Text (EN)",
      fieldValue: "download_button_text_english",
      className: "col-span-6",
      type: "text",
      name: "download_button_text_english",
      formType: "input",
      label: "Button Text (EN)",
      placeholder: "Enter Button Text (EN)",
      validation: { required: "Button Text (EN) is required" },
    },
    {
      fieldName: "Button Text (MS)",
      fieldValue: "download_button_text_malay",
      className: "col-span-6",
      type: "text",
      name: "download_button_text_malay",
      formType: "input",
      label: "Button Text (MS)",
      placeholder: "Enter Button Text (MS)",
      // validation: { required: "Button Text (MS) is required" },
    },
    {
      fieldName: "Button Text (ZH)",
      fieldValue: "download_button_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "download_button_text_mandarin",
      formType: "input",
      label: "Button Text (ZH)",
      placeholder: "Enter Button Text (ZH)",
      // validation: { required: "Button Text (ZH) is required" },
    },
    {
      fieldName: "PDF",
      fieldValue: "pdf_url",
      className: "col-span-6",
      usedFileType: ".pdf",
      type: "pdf",
      name: "pdf_url",
      formType: "file",
      label: "PDF",
      placeholder: "Enter PDF",
      validation: { required: 'PDF is Required' }
    },
  ],
  lagsGuidelinesContent: [
    {
      fieldName: "Content 1 (EN)",
      fieldValue: "description_english",
      className: "col-span-6",
      type: "text",
      name: "description_english",
      formType: "richText",
      label: "Content 1 (EN)",
      placeholder: "Enter Content 1 (EN)",
      validation: { required: "Content 1 (EN) is required" },
    },
    {
      fieldName: "Content 1 (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Content 1 (MS)",
      placeholder: "Enter Content 1 (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 1 (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Content 1 (ZH)",
      placeholder: "Enter Content 1 (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 2 (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "richText",
      label: "Content 2 (EN)",
      placeholder: "Enter Content 2 (EN)",
      validation: { required: "Content 2 (EN) is required" },
    },
    {
      fieldName: "Content 2 (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "richText",
      label: "Content 2 (MS)",
      placeholder: "Enter Content 2 (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 2 (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "richText",
      label: "Content 2 (ZH)",
      placeholder: "Enter Content 2 (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 3 (EN)",
      fieldValue: "description_english_3",
      className: "col-span-6",
      type: "text",
      name: "description_english_3",
      formType: "richText",
      label: "Content 3 (EN)",
      placeholder: "Enter Content 3 (EN)",
      validation: { required: "Content 3 (EN) is required" },
    },
    {
      fieldName: "Content 3 (MS)",
      fieldValue: "description_malay_3",
      className: "col-span-6",
      type: "text",
      name: "description_malay_3",
      formType: "richText",
      label: "Content 3 (MS)",
      placeholder: "Enter Content 3 (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 3 (ZH)",
      fieldValue: "description_mandarin_3",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_3",
      formType: "richText",
      label: "Content 3 (ZH)",
      placeholder: "Enter Content 3 (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  restrictedItems: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "field_content_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "field_content_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_ms",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "field_content_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_content_description_zh",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  restrictedItemsCheckedInCabinRestrictionsContent: [
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Title 1 (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title 1 (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title 1 (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title 1 (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title 1 (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title 1 (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Title 2 (EN)",
      fieldValue: "english_title_2",
      className: "col-span-6",
      type: "text",
      name: "english_title_2",
      formType: "input",
      label: "Title 2 (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title 2 (MS)",
      fieldValue: "malay_title_2",
      className: "col-span-6",
      type: "text",
      name: "malay_title_2",
      formType: "input",
      label: "Title 2 (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title 2 (ZH)",
      fieldValue: "mandarin_title_2",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title_2",
      formType: "input",
      label: "Title 2 (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  restrictedItemsCheckedInCabinRestrictionsImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 230,
        height: 230
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  restrictedItemsCabinOnlyRestrictionsContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title_3",
      className: "col-span-6",
      type: "text",
      name: "english_title_3",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title_3",
      className: "col-span-6",
      type: "text",
      name: "malay_title_3",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title_3",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title_3",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  restrictedItemsCabinOnlyRestrictionsImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 230,
        height: 230
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  dutyFreeBuyingGuide: [
    // {
    //   fieldName: "Title (EN)",
    //   fieldValue: "title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "title",
    //   formType: "input",
    //   label: "Title (EN)",
    //   placeholder: "Enter Title (EN)",
    //   validation: { required: "Title (EN) is required" },
    // },
    // {
    //   fieldName: "Title (MS)",
    //   fieldValue: "field_common_malay_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_common_malay_title",
    //   formType: "input",
    //   label: "Title (MS)",
    //   placeholder: "Enter Title (MS)",
    //   // validation: { required: "Title (MS) is required" },
    // },
    // {
    //   fieldName: "Title (ZH)",
    //   fieldValue: "field_common_mandarin_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_common_mandarin_title",
    //   formType: "input",
    //   label: "Title (ZH)",
    //   placeholder: "Enter Title (ZH)",
    //   // validation: { required: "Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Airports",
    //   fieldValue: "field_airport",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "field_airport",
    //   formType: "multiSelect",
    //   options: [
    //     {
    //       label: "KLIA Terminal 1",
    //       value: "klia1"
    //     },
    //     {
    //       label: "KLIA Terminal 2",
    //       value: "klia2"
    //     },
    //     {
    //       label: "Penang",
    //       value: "penang"
    //     },
    //     {
    //       label: "Kuching",
    //       value: "kuching"
    //     },
    //     {
    //       label: "Langkawi",
    //       value: "langkawi"
    //     },
    //     {
    //       label: "Kota Kinabalu",
    //       value: "kota kinabalu"
    //     },
    //   ],
    //   label: "Airports",
    //   placeholder: "Enter Airports",
    //   validation: { required: "Airports is required" },
    // },
    {
      fieldName: "Country (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Country (EN)",
      placeholder: "Enter Country (EN)",
      validation: { required: "Country (EN) is required" },
    },
    {
      fieldName: "Country (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Country (MS)",
      placeholder: "Enter Country (MS)",
      // validation: { required: "Country (MS) is required" },
    },
    {
      fieldName: "Country (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Country (ZH)",
      placeholder: "Enter Country (ZH)",
      // validation: { required: "Country (ZH) is required" },
    },
    {
      fieldName: "Spirits (EN)",
      fieldValue: "field_category_en",
      className: "col-span-6",
      type: "text",
      name: "field_category_en",
      formType: "input",
      label: "Spirits (EN)",
      placeholder: "Enter Spirits (EN)",
      validation: { required: "Spirits (EN) is required" },
    },
    {
      fieldName: "Spirits (MS)",
      fieldValue: "field_category_ms",
      className: "col-span-6",
      type: "text",
      name: "field_category_ms",
      formType: "input",
      label: "Spirits (MS)",
      placeholder: "Enter Spirits (MS)",
      // validation: { required: "Spirits (MS) is required" },
    },
    {
      fieldName: "Spirits (ZH)",
      fieldValue: "field_category_zh",
      className: "col-span-6",
      type: "text",
      name: "field_category_zh",
      formType: "input",
      label: "Spirits (ZH)",
      placeholder: "Enter Spirits (ZH)",
      // validation: { required: "Spirits (ZH) is required" },
    },
    {
      fieldName: "Cigarettes (EN)",
      fieldValue: "field_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_name_en",
      formType: "input",
      label: "Cigarettes (EN)",
      placeholder: "Enter Cigarettes (EN)",
      validation: { required: "Cigarettes (EN) is required" },
    },
    {
      fieldName: "Cigarettes (MS)",
      fieldValue: "field_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_name_ms",
      formType: "input",
      label: "Cigarettes (MS)",
      placeholder: "Enter Cigarettes (MS)",
      // validation: { required: "Cigarettes (MS) is required" },
    },
    {
      fieldName: "Cigarettes (ZH)",
      fieldValue: "field_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_name_zh",
      formType: "input",
      label: "Cigarettes (ZH)",
      placeholder: "Enter Cigarettes (ZH)",
      // validation: { required: "Cigarettes (ZH) is required" },
    },
    {
      fieldName: "Cigar & Tobacco (EN)",
      fieldValue: "field_message_en",
      className: "col-span-6",
      type: "text",
      name: "field_message_en",
      formType: "input",
      label: "Cigar & Tobacco (EN)",
      placeholder: "Enter Cigar & Tobacco (EN)",
      validation: { required: "Cigar & Tobacco (EN) is required" },
    },
    {
      fieldName: "Cigar & Tobacco (MS)",
      fieldValue: "field_message_ms",
      className: "col-span-6",
      type: "text",
      name: "field_message_ms",
      formType: "input",
      label: "Cigar & Tobacco (MS)",
      placeholder: "Enter Cigar & Tobacco (MS)",
      // validation: { required: "Cigar & Tobacco (MS) is required" },
    },
    {
      fieldName: "Cigar & Tobacco (ZH)",
      fieldValue: "field_message_zh",
      className: "col-span-6",
      type: "text",
      name: "field_message_zh",
      formType: "input",
      label: "Cigar & Tobacco (ZH)",
      placeholder: "Enter Cigar & Tobacco (ZH)",
      // validation: { required: "Cigar & Tobacco (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  // epcFAQs:[
  //   {
  //     fieldName: "Title (EN)",
  //     fieldValue: "title",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "title",
  //     formType: "input",
  //     label: "Title (EN)",
  //     placeholder: "Enter Title (EN)",
  //     validation: { required: "Title (EN) is required" },
  //   },
  //   {
  //     fieldName: "Title (MS)",
  //     fieldValue: "field_common_malay_title",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_common_malay_title",
  //     formType: "input",
  //     label: "Title (MS)",
  //     placeholder: "Enter Title (MS)",
  //     // validation: { required: "Title (MS) is required" },
  //   },
  //   {
  //     fieldName: "Title (ZH)",
  //     fieldValue: "field_common_mandarin_title",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_common_mandarin_title",
  //     formType: "input",
  //     label: "Title (ZH)",
  //     placeholder: "Enter Title (ZH)",
  //     // validation: { required: "Title (ZH) is required" },
  //   },
  //   {
  //     fieldName: "Country",
  //     fieldValue: "country",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "country",
  //     formType: "input",
  //     label: "Country",
  //     placeholder: "Enter Country",
  //     validation: { required: "Country is required" },
  //   },
  //   {
  //     fieldName: "Spirits (EN)",
  //     fieldValue: "field_category_en",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_category_en",
  //     formType: "input",
  //     label: "Spirits (EN)",
  //     placeholder: "Enter Spirits (EN)",
  //     validation: { required: "Spirits (EN) is required" },
  //   },
  //   {
  //     fieldName: "Spirits (MS)",
  //     fieldValue: "field_category_ms",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_category_ms",
  //     formType: "input",
  //     label: "Spirits (MS)",
  //     placeholder: "Enter Spirits (MS)",
  //     // validation: { required: "Spirits (MS) is required" },
  //   },
  //   {
  //     fieldName: "Spirits (ZH)",
  //     fieldValue: "field_category_zh",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_category_zh",
  //     formType: "input",
  //     label: "Spirits (ZH)",
  //     placeholder: "Enter Spirits (ZH)",
  //     // validation: { required: "Spirits (ZH) is required" },
  //   },
  //   {
  //     fieldName: "Cigarettes (EN)",
  //     fieldValue: "field_name_en",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_name_en",
  //     formType: "input",
  //     label: "Cigarettes (EN)",
  //     placeholder: "Enter Cigarettes (EN)",
  //     validation: { required: "Cigarettes (EN) is required" },
  //   },
  //   {
  //     fieldName: "Cigarettes (MS)",
  //     fieldValue: "field_name_ms",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_name_ms",
  //     formType: "input",
  //     label: "Cigarettes (MS)",
  //     placeholder: "Enter Cigarettes (MS)",
  //     // validation: { required: "Cigarettes (MS) is required" },
  //   },
  //   {
  //     fieldName: "Cigarettes (ZH)",
  //     fieldValue: "field_name_zh",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_name_zh",
  //     formType: "input",
  //     label: "Cigarettes (ZH)",
  //     placeholder: "Enter Cigarettes (ZH)",
  //     // validation: { required: "Cigarettes (ZH) is required" },
  //   },
  //   {
  //     fieldName: "Cigar & Tobacco (EN)",
  //     fieldValue: "field_message_en",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_message_en",
  //     formType: "input",
  //     label: "Cigar & Tobacco (EN)",
  //     placeholder: "Enter Cigar & Tobacco (EN)",
  //     validation: { required: "Cigar & Tobacco (EN) is required" },
  //   },
  //   {
  //     fieldName: "Cigar & Tobacco (MS)",
  //     fieldValue: "field_message_ms",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_message_ms",
  //     formType: "input",
  //     label: "Cigar & Tobacco (MS)",
  //     placeholder: "Enter Cigar & Tobacco (MS)",
  //     // validation: { required: "Cigar & Tobacco (MS) is required" },
  //   },
  //   {
  //     fieldName: "Cigar & Tobacco (ZH)",
  //     fieldValue: "field_message_zh",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_message_zh",
  //     formType: "input",
  //     label: "Cigar & Tobacco (ZH)",
  //     placeholder: "Enter Cigar & Tobacco (ZH)",
  //     // validation: { required: "Cigar & Tobacco (ZH) is required" },
  //   },
  // ],
};
